import { Col, Form, FormProps, Input, Modal, ModalProps, Row, Select, Space, useSelect, Typography } from '@pankod/refine-antd'
import { useTable } from '@pankod/refine-core'
import { IBloomLevel, ICompetency, IDifficultyLevel, IQuestionType, IReportTheme, IStrand, ISubject, ISubTheme, ITheme, ITopic } from 'interfaces'
import React, { useEffect, useState } from 'react'
import { availableLanguages } from 'utility/languages'
type CreatePaperTemplateProps = {
  modalProps: ModalProps
  formProps: FormProps
  record: any
  testTrackQueryResult: any
  sectionTotal: any
  sectionId: any
  // refreshDataSection: any
}
export const EditSubSection: React.FC<CreatePaperTemplateProps> = ({
  modalProps,
  formProps,
  record,
  testTrackQueryResult,
  sectionId,
  sectionTotal,
  // refreshDataSection,
}) => {
  const [marks, setMarks] = useState<number>(0)
  const [questionCount, setQuestionCount] = useState<number>(0)
  const [disabled, setDisabled] = useState<boolean>(false)
  const [questionLimitExceed, setQuestionLimitExceed] = useState<boolean>(false)
  const [marksLimitExceed, setMarksLimitExceed] = useState<boolean>(false)
  const [selectedTopic, setSelectedTopic] = useState(formProps?.initialValues?.topic_id || '')
  const [baseLanguage, setBaseLanguage] = useState(record?.base_lang || '')

  const [hasEdited, setHasEdited] = useState<boolean>(false) // check if user altered marks or questions

  const { setFilters: setSubjectFilter, tableQueryResult: subjectkQueryResult } = useTable<ISubject>({
    resource: 'subjects',
    metaData: {
      fields: ['id', 'name'],
    },
    initialPageSize: 1000,
    queryOptions: { enabled: !!modalProps?.visible },
  })
  const {
    tableQueryResult: topicResult,
    filters: topicFilters,
    setFilters: setTopicFilters,
    sorter,
  } = useTable<ITopic>({
    resource: 'topics',
    initialPageSize: 10000,
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    metaData: { fields: ['id', 'name', 'sub_theme_id'] },
    queryOptions: { enabled: !!modalProps?.visible },
    // initialFilter: [{ field: 'sub_theme_id', operator: 'eq', value: formProps?.initialValues?.sub_theme_id }],
  })
  const {
    filters: reportThemeFilters,
    setFilters: setReportThemeFilters,
    tableQueryResult: reportThemeResult,
  } = useTable<IReportTheme>({
    resource: 'report_themes',
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name', 'subject_id'] },
    queryOptions: { enabled: !!modalProps?.visible },
    // initialFilter: [{ field: 'subject_id', operator: 'eq', value: formProps?.initialValues?.subject_id }],
  })
  const {
    filters: themeFilters,
    setFilters: setThemeFilters,
    tableQueryResult: themeResult,
  } = useTable<ITheme>({
    resource: 'themes',
    initialPageSize: 10000,
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    metaData: { fields: ['id', 'name', 'subject_id'] },
    queryOptions: { enabled: !!modalProps?.visible },
    // initialFilter: [{ field: 'subject_id', operator: 'eq', value: formProps?.initialValues?.subject_id }],
  })
  const { selectProps: reportThemeProps, queryResult: reportThemeQueryResult } = useSelect<IReportTheme>({
    resource: 'report_themes',
    optionLabel: 'name',
    optionValue: 'id',
    fetchSize: 10000,
    metaData: {
      fields: ['id', 'name', 'topic_ids', 'theme_ids'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    filters: [
      {
        field: 'theme_ids',
        operator: 'nnull',
        value: true,
      },
    ],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],

    queryOptions: { enabled: !!modalProps?.visible },
  })

  const {
    filters: subThemeFilters,
    setFilters: setSubThemeFilters,
    tableQueryResult: subThemeResult,
  } = useTable<ISubTheme>({
    resource: 'sub_themes',
    initialPageSize: 1000,
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    metaData: { fields: ['id', 'name', 'theme_id'] },
    queryOptions: { enabled: !!modalProps?.visible },
    // initialFilter: [{ field: 'theme_id', operator: 'eq', value: formProps?.initialValues?.theme_id }],
  })
  const { selectProps: questionTypeSelectProps } = useSelect<IQuestionType>({
    resource: 'question_types',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    queryOptions: { enabled: !!modalProps?.visible },
  })
  //blooms details
  const { tableQueryResult: bloomsResults } = useTable<IBloomLevel>({
    resource: 'blooms_levels',
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name'] },
  })
  //difficulty details
  const { tableQueryResult: difficultyResults } = useTable<IDifficultyLevel>({
    resource: 'difficulty_levels',
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name'] },
  })
  //competencies details
  const { tableQueryResult: competencyResults } = useTable<ICompetency>({
    resource: 'competencies',
    initialPageSize: 1000,
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    metaData: { fields: ['id', 'name'] },
  })
  //strands
  const { tableQueryResult: strandsResults } = useTable<IStrand>({
    resource: 'strands',
    initialPageSize: 1000,
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    metaData: { fields: ['id', 'name'] },
  })

  useEffect(() => {
    if (record?.test_track_id !== '' && record?.test_track_id !== null && record?.test_track_id !== undefined) {
      setSubjectFilter([
        {
          field: 'id',
          operator: 'in',
          value: testTrackQueryResult?.data?.data[0]?.subject_ids ?? [],
        },
      ])
      //   setShowSubjectData(true)
    } else {
      //   setShowSubjectData(false)
    }
  }, [testTrackQueryResult?.data?.data])
  const handleSubjectChange = (value: { value: any }) => {
    reportThemeFilters.pop()
    themeFilters.pop()
    formProps?.form?.setFieldsValue({
      report_theme_id: null,
      sub_theme_id: null,
      topic_id: null,
      theme_id: null,
      questionResult: null,
    })
    setReportThemeFilters([
      {
        field: 'subject_id',
        operator: 'eq',
        value: value,
      },
    ])
    setThemeFilters([
      {
        field: 'subject_id',
        operator: 'eq',
        value: value,
      },
    ])
  }

  // const handleReportThemeChange = (value: { value: any }) => {
  //   themeFilters.pop()
  //   formProps?.form?.setFieldsValue({
  //     theme_id: null,
  //     sub_theme_id: null,
  //     topic_id: null,
  //   })
  //   setThemeFilters([
  //     {
  //       field: 'report_theme_id',
  //       operator: 'eq',
  //       value: value,
  //     },
  //   ])
  // }

  const handleThemeChange = (value: { value: any }) => {
    subThemeFilters.pop()
    formProps?.form?.setFieldsValue({
      sub_theme_id: null,
      topic_id: null,
      report_theme_id: null,
    })
    setSubThemeFilters([
      {
        field: 'theme_id',
        operator: 'eq',
        value: value,
      },
    ])
    setSelectedTopic(value)
  }
  const handleSubThemeChange = (value: { value: any }) => {
    topicFilters.pop()
    formProps?.form?.setFieldsValue({
      topic_id: null,
    })
    setTopicFilters([
      {
        field: 'sub_theme_id',
        operator: 'eq',
        value: value,
      },
    ])
  }

  useEffect(() => {
    if (formProps?.initialValues) {
      setSubThemeFilters([{ field: 'theme_id', operator: 'eq', value: formProps?.initialValues?.theme_id }])
      setReportThemeFilters([{ field: 'subject_id', operator: 'eq', value: formProps?.initialValues?.subject_id }])
      setThemeFilters([{ field: 'subject_id', operator: 'eq', value: formProps?.initialValues?.subject_id }])
      setTopicFilters([{ field: 'sub_theme_id', operator: 'eq', value: formProps?.initialValues?.sub_theme_id }])

      //set initial ques and marks
      setMarks(formProps?.initialValues.mark_per_question)
      setQuestionCount(formProps?.initialValues.no_of_questions)
    }
  }, [formProps?.initialValues])

  const checkValidation = () => {
    // alert('enter')
    let disableSave = false
    let marksExceed = false
    let quesExceed = false
    let marksLimit = 0
    let questionsLimit = 0
    record?.product.sections.forEach((section: any) => {
      if (section.section_id === sectionId) {
        marksLimit = +section.marks
        questionsLimit = +section.no_of_questions
      }
    })

    if (sectionTotal.length > 0) {
      let foundSection = sectionTotal.findIndex((elem: any) => elem?.section_id === sectionId)
      console.log('foundSection', { foundSection })
      if (foundSection !== -1) {
        if (hasEdited) {
          // alert(1)
          let newMark =
            +sectionTotal[foundSection]?.total_mark - +formProps?.initialValues?.mark_per_question * +formProps?.initialValues?.no_of_questions
          let newQue = +sectionTotal[foundSection]?.question_count - +formProps?.initialValues?.no_of_questions
          marksExceed = newMark + marks * questionCount > marksLimit ? true : false
          quesExceed = newQue + questionCount > questionsLimit ? true : false
          disableSave = marksExceed || quesExceed
        }
      }
    }
    // console.log('limit set', marksLimit, questionsLimit, sectionTotal)
    // sectionTotal.forEach(({ total_mark, section_id, question_count }: any) => {
    //   alert(0)
    //   // console.log('section_id', section_id)
    //   // console.log('sectionId', sectionId)
    //   if (section_id === sectionId) {
    //     alert(1)
    //     console.log('curr stats', total_mark, question_count)
    //     if (total_mark !== undefined && question_count !== undefined) {
    //       // above condition : checking if not undefined
    //       if (hasEdited) {
    //         let newMark = +total_mark - +formProps?.initialValues?.mark_per_question * +formProps?.initialValues?.no_of_questions
    //         let newQue = +question_count - +formProps?.initialValues?.no_of_questions
    //         console.log('deductions', newMark, newQue)
    //         console.log('marks/q, qcount', marks, questionCount)
    //         marksExceed = marksLimit < newMark + Number(marks) * Number(questionCount)
    //         quesExceed = questionsLimit < newQue + +questionCount
    //       } else {
    //         marksExceed = marksLimit < Number(total_mark)
    //         quesExceed = questionsLimit < +question_count
    //       } //questionCount and marks are current form data
    //       disableSave = marksExceed || quesExceed
    //     }
    //   } else {
    //     alert(2)
    //     console.log('else', marksLimit, questionsLimit)
    //     marksExceed = marksLimit < Number(total_mark)
    //     quesExceed = questionsLimit < +question_count
    //     disableSave = marksExceed || quesExceed
    //   }
    // })
    setDisabled(disableSave)
    setMarksLimitExceed(marksExceed)
    setQuestionLimitExceed(quesExceed)
  }

  useEffect(() => {
    checkValidation()
  }, [questionCount, marks])

  const onFinish = async (values: any) => {
    values.competency_id = values?.competency_id || null
    values.strand_id = values?.strand_id || null
    values.base_lang = values?.base_lang || null
    values.target_lang = values?.target_lang || null
    return (
      formProps.onFinish &&
      formProps.onFinish({
        ...values,
        section_id: sectionId,
        paper_template_id: record?.id,
      })
    )
  }
  return (
    <Modal
      // afterClose={() => refreshDataSection()}
      {...modalProps}
      title="Edit Sub Section"
      okButtonProps={{ ...modalProps.okButtonProps, disabled: disabled }}
      afterClose={() => {
        setMarks(0)
        setQuestionCount(0)
        setDisabled(false)
        setQuestionLimitExceed(false)
        setMarksLimitExceed(false)
        setHasEdited(false)
        formProps?.form?.resetFields()
      }}
    >
      <Form
        {...formProps}
        layout="vertical"
        onFinish={values =>
          onFinish(values).then(() => {
            formProps?.form?.resetFields()
          })
        }
      >
        <Space style={{ display: 'flex', marginBottom: 8 }} align="baseline">
          <Row gutter={[8, 0]}>
            <Col xs={24} lg={3}>
              <Form.Item name={'name'} rules={[{ required: true, message: 'Missing Section' }]}>
                <Input placeholder="Name" type="small" />
              </Form.Item>
            </Col>

            <Col xs={24} lg={3}>
              <Form.Item name={'subject_id'} rules={[{ required: true }]}>
                <Select
                  placeholder="Subject"
                  onChange={handleSubjectChange}
                  showSearch
                  filterOption={(input, option) => {
                    if (option && option.children) {
                      return option.children.toString().toLowerCase().includes(input.toLowerCase())
                    }
                    return false
                  }}
                  optionFilterProp="children"
                >
                  {subjectkQueryResult?.data?.data?.map((item: any) => (
                    <option value={item?.id}>{item?.name}</option>
                  ))}
                  {/* {subjectList.length > 0 && subjectList.map((item: any) => <option value={item?.id}>{item?.name}</option>)} */}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} lg={3}>
              <Form.Item name={'theme_id'} rules={[{ required: true }]}>
                <Select
                  placeholder="Theme"
                  onChange={handleThemeChange}
                  showSearch
                  filterOption={(input, option) => {
                    if (option && option.children) {
                      return option.children.toString().toLowerCase().includes(input.toLowerCase())
                    }
                    return false
                  }}
                  optionFilterProp="children"
                >
                  {themeResult?.data?.data?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Form.Item>{' '}
            </Col>
            {/* Report Theme__________________________ */}
            <Col xs={24} lg={3}>
              <Form.Item name={'report_theme_id'} rules={[{ required: true }]}>
                <Select
                  placeholder="Report Theme"
                  showSearch
                  allowClear
                  filterOption={(input, option) => {
                    if (option && option?.children) {
                      return option?.children?.toString().toLowerCase().includes(input.toLowerCase())
                    }
                    return false
                  }}
                  optionFilterProp="children"
                >
                  {reportThemeQueryResult?.data?.data?.map(item => {
                    let themeValue = formProps.form?.getFieldValue('theme_id')
                    if (item?.theme_ids && item?.theme_ids.includes(selectedTopic || themeValue)) {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      )
                    }
                  })}
                </Select>
              </Form.Item>
            </Col>
            {/* ______________________Report Theme */}
            <Col xs={24} lg={3}>
              <Form.Item name={'sub_theme_id'} rules={[{ required: true }]}>
                <Select
                  placeholder="Sub Theme"
                  onChange={handleSubThemeChange}
                  showSearch
                  filterOption={(input, option) => {
                    if (option && option.children) {
                      return option.children.toString().toLowerCase().includes(input.toLowerCase())
                    }
                    return false
                  }}
                  optionFilterProp="children"
                >
                  {subThemeResult?.data?.data?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} lg={3}>
              <Form.Item
                name={'topic_id'}
                // rules={[{ required: true }]}
              >
                <Select
                  placeholder="Topic"
                  allowClear
                  onChange={value => {
                    formProps.form?.setFieldsValue({
                      topic_id: value || null,
                    })
                    setSelectedTopic(value)
                  }}
                  showSearch
                  filterOption={(input, option) => {
                    if (option && option.children) {
                      return option.children.toString().toLowerCase().includes(input.toLowerCase())
                    }
                    return false
                  }}
                  optionFilterProp="children"
                >
                  {topicResult?.data?.data?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            {/* <Col xs={24} lg={3}>
              <Form.Item name={'report_theme_id'} rules={[{ required: true }]}>
                <Select
                  placeholder="Report Theme"
                  showSearch
                  filterOption={(input, option) => {
                    if (option && option?.children) {
                      return option?.children?.toString().toLowerCase().includes(input.toLowerCase())
                    }
                    return false
                  }}
                  optionFilterProp="children"
                >
                  {reportThemeQueryResult?.data?.data?.map(item => {
                    let topicValue = formProps.form?.getFieldValue('topic_id')
                    if (item.topic_ids && item.topic_ids.includes(selectedTopic || topicValue)) {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      )
                    }
                  })}
                </Select>
              </Form.Item>
            </Col> */}

            {/* bloom */}
            <Col xs={24} lg={3}>
              <Form.Item name={'blooms_level_id'} rules={[{ required: true }]}>
                <Select placeholder="Blooms Level">
                  {bloomsResults?.data?.data?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            {/* difficulty */}
            <Col xs={24} lg={3}>
              <Form.Item name={'difficult_level_id'} rules={[{ required: true }]}>
                <Select placeholder="Difficulty Level">
                  {difficultyResults?.data?.data?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            {/* competency */}
            <Col xs={24} lg={3}>
              <Form.Item name={'competency_id'} rules={[{ required: false }]}>
                <Select placeholder="Competency" allowClear>
                  {competencyResults?.data?.data?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            {/* strand */}
            <Col xs={24} lg={3}>
              <Form.Item name={'strand_id'} rules={[{ required: false }]}>
                <Select placeholder="Standard" allowClear>
                  {strandsResults?.data?.data?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} lg={2}>
              <Form.Item name={'question_type_id'} rules={[{ required: true }]}>
                <Select {...questionTypeSelectProps} placeholder="Question Type" />
              </Form.Item>
            </Col>
            <Col xs={24} lg={2}>
              <Form.Item name={'no_of_questions'} rules={[{ required: true, message: 'Missing No of Questions' }]}>
                <Input
                  placeholder="No of Questions"
                  type="small"
                  onChange={e => {
                    setHasEdited(true)
                    setQuestionCount(parseInt(e.target.value))
                  }}
                />
              </Form.Item>
              {questionLimitExceed && <Typography.Text type="danger">Questions Exceeded !!</Typography.Text>}
            </Col>
            <Col xs={24} lg={2}>
              <Form.Item name={'mark_per_question'} rules={[{ required: true, message: 'Missing Marks' }]}>
                <Input
                  placeholder="Mark per Question"
                  type="small"
                  onChange={e => {
                    setHasEdited(true)
                    setMarks(parseInt(e.target.value))
                  }}
                />
              </Form.Item>
              {marksLimitExceed && <Typography.Text type="danger">Marks Exceeded !!</Typography.Text>}
            </Col>

            <Col xs={24} lg={2}>
              <Form.Item name={'base_lang'}>
                <Select
                  placeholder="Base Language"
                  onChange={value => {
                    setBaseLanguage(value)
                    formProps?.form?.setFieldsValue({
                      target_lang: null,
                    })
                  }}
                  allowClear
                >
                  {availableLanguages.map(lang => (
                    <option key={lang.label} value={lang.value}>
                      {lang.label}
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} lg={3}>
              <Form.Item name={'target_lang'}>
                <Select placeholder="Target Language" allowClear>
                  {availableLanguages.map(lang => {
                    if (baseLanguage !== lang.value) {
                      return (
                        <option key={lang.label} value={lang.value}>
                          {lang.label}
                        </option>
                      )
                    }
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Form.Item name={'paper_template_id'} initialValue={record?.id}>
              <Input type="hidden" />
            </Form.Item>
          </Row>
          {/* <MinusCircleOutlined onClick={() => removeSection(item?.id)} /> */}
        </Space>
        {/* <Form.Item>
            <Button type="dashed" onClick={() => addNewSubSection(currentSectionId)} block icon={<PlusOutlined />}>
              Save
            </Button>
          </Form.Item> */}
      </Form>
    </Modal>
  )
}
